// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { N50, N70 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var StyledClearButton = styled.div({
  background: 0,
  border: 0,
  borderRadius: "var(--ds-radius-xsmall, 2px)",
  color: "var(--ds-text-subtlest, ".concat(N50, ")"),
  cursor: 'pointer',
  height: "var(--ds-space-300, 24px)",
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: 1,
  outline: 0,
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  marginLeft: "var(--ds-space-025, 2px)",
  transition: 'background-color 200ms opacity 200ms',
  width: "var(--ds-space-300, 24px)",
  '&:hover, &:focus': {
    color: "var(--ds-text-subtle, ".concat(N70, ")")
  }
});